import React from 'react';
import { Drawer, Typography, Space, List, Button } from 'antd';
import slidesIcon from '../../../../assets/DasboardIcons/slides.svg';
import gridIcon from '../../../../assets/DasboardIcons/grid.png';
import boardIcon from '../../../../assets/DasboardIcons/board.png';
import mindmapIcon from '../../../../assets/DasboardIcons/mindmap.svg';
import ideationIcon from '../../../../assets/DasboardIcons/ideation.svg';
import spacesIcon from '../../../../assets/DasboardIcons/spaces.svg';
import padIcon from '../../../../assets/DasboardIcons/pad.png';
import WorkWsieIcon from '../../../ResultComponent/WorkWsieIcon';

const ApplicationsDrawer = ({ open, onClose }) => {


  const appUrls = {
    pad: 'https://pad.workw.com/',
    grid: 'https://grid.workw.com/',
    board: 'https://board.workw.com/',
    mindmap: 'https://map.workw.com/',
    spaces: 'https://spaces.workw.com/',
    ideation: 'https://ideation.workw.com/',
  };

  const handleAppClick = (id) => {
    const url = appUrls[id];
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const customTitle = (
    <Space align="center" size={8}>
      <WorkWsieIcon width="80" height="40" logoOnly={false} textColor='#000' />
      <Typography.Text style={{ fontSize: 24, fontWeight: 300, color: 'rgba(0,0,0,0.88)' }}>
        Slide
      </Typography.Text>
    </Space>
  );

  const items = [
    { id: 'pad', name: 'Pad', icon: padIcon },
    { id: 'grid', name: 'Grid', icon: gridIcon },
    { id: 'board', name: 'Board', icon: boardIcon },
    { id: 'mindmap', name: 'Mindmap', icon: mindmapIcon },
    { id: 'ideation', name: 'Ideation', icon: ideationIcon },
    { id: 'spaces', name: 'Spaces', icon: spacesIcon },
  ];

  return (
    <Drawer
      title={customTitle}
      placement="left"
      onClose={onClose}
      visible={open}
      closable={false}
      width={300}
      bodyStyle={{ padding: 16, background: 'white' }}
      zIndex={1050}
      mask={true}
      style={{ position: 'absolute' }}
      headerStyle={{ borderBottom: '1px solid #f0f0f0', paddingLeft: '10px' }}
    >
      <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
        <List
          dataSource={items}
          split
          renderItem={(item) => (
            <List.Item style={{ padding: 0, borderBlockEndColor: '#f4f4f4' }}>
              <Button
                key={item.id}
                type="text"
                block
                onClick={() => handleAppClick(item.id)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  padding: '10px 12px',
                  borderRadius: 8,
                  height: 'auto',
                  textAlign: 'left',
                }}
              >
                <img src={item.icon} alt={item.name} style={{ height: 24, width: 22, objectFit: 'contain' }} />
                <Typography.Text style={{ fontSize: 14, color: 'rgba(0,0,0,0.88)' }}>{item.name}</Typography.Text>
              </Button>
            </List.Item>
          )}
        />
      </Space>
    </Drawer>
  );
};

export default ApplicationsDrawer;